import { createSlice } from "@reduxjs/toolkit";

const initValue = {
  detail: {},
  userStatus: { authen: false },
  userRule: {},
  userMenus: [],
  lineProfile: {},
  curAuthen: { username: "", password: "" },
};

const userSlice = createSlice({
  name: "user",
  initialState: initValue,
  reducers: {
    login: (state, action) => {
      //   console.log(action.payload);
      state.detail = action.payload.Detail[0];
      state.userRule = action.payload.UserRule[0];
      state.userMenus = action.payload.Menu;
      state.lineProfile = action.payload.LineProfile;
      state.userStatus.authen = true;
    },
    logout: (state) => {
      state.detail = {};
      state.userRule = {};
      state.userStatus.authen = false;
      state.userMenus = [];
      state.userProfile = {};
    },
    setCurAuthen: (state, action) => {
      state.curAuthen.username = action.payload.username;
      state.curAuthen.password = action.payload.password;
    },
  },
});

const { actions, reducer } = userSlice;

export const { login, logout, setCurAuthen } = actions;

export default reducer;
